import { createElement, Component } from 'react';
import { string, object } from 'prop-types';
import 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import _get from 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
import { f as _defineProperty, e as _inheritsLoose, g as _assertThisInitialized, a as _objectSpread, c as _extends, b as _objectWithoutPropertiesLoose } from '../chunk-ad6ad343.js';
import 'polished';
import '../default/palette.js';
import Box from 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import '../Icon/styled.js';
import 'classnames';
import 'reakit/Heading';
import '../Heading/styled.js';
import Heading from '../Heading/index.js';
import '../Text/styled.js';
import Text from '../Text/index.js';
import 'reakit/Blockquote';
import '../Blockquote/styled.js';
import Blockquote from '../Blockquote/index.js';
import 'reakit/List';
import '../List/styled.js';
import '../List/ListItem.js';
import List from '../List/index.js';
import 'reakit/Link';
import '../Link/styled.js';
import Link from '../Link/index.js';
import 'conditional-wrap';
import 'reakit/Divider';
import '../Divider/styled.js';
import Divider from '../Divider/index.js';
import 'reakit/Image';
import '../Image/styled.js';
import Image from '../Image/index.js';
import MarkdownRenderer from 'markdown-react-js';
import 'reakit/Paragraph';
import '../Paragraph/styled.js';
import Paragraph from '../Paragraph/index.js';
import '../Table/styled.js';
import '../Table/TableBody.js';
import '../Table/TableCaption.js';
import '../Table/TableCell.js';
import '../Table/TableFoot.js';
import '../Table/TableHead.js';
import '../Table/TableHeadCell.js';
import '../Table/TableRow.js';
import Table from '../Table/index.js';

var tags = function tags(props) {
  return {
    p: {
      Component: Paragraph,
      props: _get(props, 'elementProps.p', {})
    },
    strong: {
      Component: Text,
      props: _objectSpread({
        fontWeight: 'bold'
      }, _get(props, 'elementProps.strong', {}))
    },
    em: {
      Component: Text,
      props: _objectSpread({
        use: 'em'
      }, _get(props, 'elementProps.em', {}))
    },
    a: {
      Component: Link,
      props: _get(props, 'elementProps.a', {})
    },
    blockquote: {
      Component: Blockquote,
      props: _get(props, 'elementProps.blockquote', {})
    },
    h1: {
      Component: Heading,
      props: _objectSpread({
        use: 'h1'
      }, _get(props, 'elementProps.h1', {}))
    },
    h2: {
      Component: Heading,
      props: _objectSpread({
        use: 'h2'
      }, _get(props, 'elementProps.h2', {}))
    },
    h3: {
      Component: Heading,
      props: _objectSpread({
        use: 'h3'
      }, _get(props, 'elementProps.h3', {}))
    },
    h4: {
      Component: Heading,
      props: _objectSpread({
        use: 'h4'
      }, _get(props, 'elementProps.h4', {}))
    },
    h5: {
      Component: Heading,
      props: _objectSpread({
        use: 'h5'
      }, _get(props, 'elementProps.h5', {}))
    },
    h6: {
      Component: Heading,
      props: _objectSpread({
        use: 'h6'
      }, _get(props, 'elementProps.h6', {}))
    },
    hr: _objectSpread({
      Component: Divider
    }, _get(props, 'elementProps.hr', {})),
    ul: {
      Component: List,
      props: _objectSpread({
        listStyleType: 'disc',
        listStylePosition: 'inside'
      }, _get(props, 'elementProps.ul', {}))
    },
    ol: {
      Component: List,
      props: _objectSpread({
        isOrdered: true,
        listStylePosition: 'inside'
      }, _get(props, 'elementProps.ol', {}))
    },
    li: {
      Component: List.Item,
      props: _get(props, 'elementProps.li', {})
    },
    table: {
      Component: Table,
      props: _get(props, 'elementProps.table', {})
    },
    tbody: {
      Component: Table.Body,
      props: _get(props, 'elementProps.tbody', {})
    },
    thead: {
      Component: Table.Head,
      props: _get(props, 'elementProps.thead', {})
    },
    tfoot: {
      Component: Table.Foot,
      props: _get(props, 'elementProps.tfoot', {})
    },
    tr: {
      Component: Table.Row,
      props: _get(props, 'elementProps.tr', {})
    },
    td: {
      Component: Table.Cell,
      props: _get(props, 'elementProps.td', {})
    },
    th: {
      Component: Table.HeadCell,
      props: _get(props, 'elementProps.th', {})
    },
    img: {
      Component: Image,
      props: _get(props, 'elementProps.img', {})
    }
  };
};

var markdownPropTypes = {
  content: string.isRequired,
  elementProps: object
};
var markdownDefaultProps = {
  elementProps: {}
};
var Markdown =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Markdown, _React$Component);

  function Markdown() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "handleIterate", function (Tag, props, children) {
      var _ref = tags(_this.props)[Tag] || {
        Component: Tag
      },
          Component = _ref.Component,
          _ref$props = _ref.props,
          overrideProps = _ref$props === void 0 ? {} : _ref$props;

      return (// @ts-ignore
        createElement(Component, _extends({}, props, overrideProps || {}), children)
      );
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var _this$props = _this.props,
          content = _this$props.content,
          props = _objectWithoutPropertiesLoose(_this$props, ["content"]);

      return createElement(Box, props, createElement(MarkdownRenderer, {
        onIterate: _this.handleIterate,
        text: content
      }));
    });

    return _this;
  }

  return Markdown;
}(Component);

_defineProperty(Markdown, "propTypes", markdownPropTypes);

_defineProperty(Markdown, "defaultProps", markdownDefaultProps);

var C = Markdown;

export default C;
export { C as Markdown, markdownDefaultProps, markdownPropTypes };
